import { RootState } from 'store';

export const companyOnboardingProgressSelector = (state: RootState) => state.onboarding.progress;
